export default __webpack_public_path__ + "static/media/faq-icon.7f70f83b.svg";